import React from 'react';
import BaseDetailPage from '../../_CustomComponents/BaseDetailPage';
import ReactToPrint from "react-to-print";
import { Navigate } from "react-router-dom";
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import * as inspectionCrud from '../../../../crud/inspectionDefect.crud';
import * as fileCrud from '../../../../crud/file.crud';
import axios from 'axios';
import ActionModal from '../../_CustomComponents/ActionModal';
import IssueDocument from './Document';
import ReplyDocument from './DocumentReply';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import { Alert } from "react-bootstrap";
import { addDays } from 'date-fns';
import { ValidationSummary, ValidationGroup } from 'devextreme-react';
import moment from 'moment';
import Relations from '../../_CustomComponents/Relation/Relations';
import { FormattedMessage } from "react-intl";
import PageToolbar from '../../_CustomComponents/PageToolbar';
import Common from '../../../../shared/common';
import { withDetailPageProps } from '../../../../shared/hoc/withDetailPageProps';
import NavigationBlocker from '../../../../partials/Tools/NavigationBlocker';
import EmailNotifications from '../../_CustomComponents/EmailNotifications';
import { confirm } from 'devextreme/ui/dialog';
import NotificationContext from '../../../../../notificationContext';

const initialState = {
    notification: null,
    files: null,
    showModal: false,
    saving: false,
    // isDxFormValid: true,
    isChanged: false,
    //NEW REPLY STATES
    reply: null,
    replyFiles: null,
    isAwaitingReply: false,
    modalTitle: '',
    modalText: '',
    modalMode: '',
    relationCount: 0,
    postActionUrl: null,
    relations: null,
    selectedClause: null,
    oldReplyRequiredDate: '',
    selectedReply: null
};

class IssueDetail extends BaseDetailPage {
    constructor(props) {
        super(props);

        this.isRelationsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true' || process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true';
        this.printIssueDivRef = React.createRef();
        this.printAcceptanceDivRef = React.createRef();
        //NEW REPLY
        this.validatorRef = React.createRef();
        this.validatorName = 'IssueValidator';

        this.state = { ...initialState };
    }

    static contextType = NotificationContext;
    
    componentDidMount() {
        this.fetchInspectionDefect();
        this.fetchFiles();
        this.fetchReplyFiles();
    }

    componentWillUnmount() {
        this.context.updateNotificationContext({
            documentIsFinal: false,
            path: null,
            referenceId: null,
            referenceType: null,
            workflowGroupId: null,
            workflowId: null,
        });
    }


    componentDidUpdate(prevprops, prevSatate) {
        if (this.props.params.notificationid !== prevprops.params.notificationid) {
            this.setState({ ...initialState }, () => {
                this.fetchInspectionDefect();
                this.fetchFiles();
                this.fetchReplyFiles();
            });
        }
    }

    getMailDescription = () => {
        return this.state.notification.replyactiondetail;
    }
    getSelectedTypeClauseDisplay = () => {
        return this.state.notification.inspectiontime;
    }
    fetchInspectionDefect = () => {
        const { fields, replyFields } = this.props.workflowItem;
        inspectionCrud.getInspectionDefect(this.props.params.notificationid)
            .then(response => {
                const defect = response.data;
                if (defect.contractid !== this.props.contract.contractid ||
                    defect.type !== this.props.notificationType) {
                    throw new Error(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.INVALID_URL' }));
                }
                if (defect.createdate) {
                    defect.createdate = new Date(defect.createdate);
                }
                if (defect.inspectiondate) {
                    defect.inspectiondate = new Date(defect.inspectiondate);
                }
                if (defect.notificationdate) {
                    defect.notificationdate = new Date(defect.notificationdate);
                }
                if (defect.draftreplydate) {
                    defect.draftreplydate = new Date(defect.draftreplydate);
                }
                if (defect.replyrequireddate) {
                    defect.replyrequireddate = new Date(defect.replyrequireddate);
                }
                let selectedClause = null;
                if (defect.inspectiontime && fields.Type.clauses) {
                    selectedClause = fields.Type.clauses.find(c => c.display === defect.inspectiontime);
                    if (selectedClause) {
                    }
                    else {
                        if (defect.showtasknotification !== 1) {
                            defect.inspectiontime = null;
                            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_CLAUSE_MISSING' }), { variant: 'warning', });
                        }
                    }
                }

                const overrideProps = {
                    overrideReplyParty: false,
                    overrideSaveDraftReplyAllowed: false,
                    overrideCommunicateReplyAllowed: false
                }
                if (this.props.workflowItem.replyEnabled) {
                    if (selectedClause && selectedClause.overrideReplyingParty) {
                        overrideProps.overrideReplyParty = true;
                        overrideProps.overrideSaveDraftReplyAllowed = this.getOverrideReplyDraftAllowed(defect.replyingparty);
                        overrideProps.overrideCommunicateReplyAllowed = this.getOverrideReplyCommunicateAllowed(defect.replyingparty);
                    }
                }

                const awaitingReply = (defect.showtasknotification === 1 && defect.replystatus === 'Awaiting Acceptance' && defect.isreplyrequired);
                const replyItem = {
                    replystatus: defect.draftinspectionstatus,
                    replycomment: defect.draftreplycomment,
                    customfieldvalues: defect.customfieldvalues
                };

                this.setState({
                    notification: defect,
                    oldReplyRequiredDate: defect.replyrequireddate,
                    reply: replyItem,
                    isAwaitingReply: awaitingReply,
                    saving: false,
                    isChanged: false,
                    relations: defect.relations,
                    relationCount: Common.GetRelationCount(defect, this.props.accessibleWfIds),
                    ...overrideProps
                }, () => { 
                    this.props.setReference(this.state.notification.referenceid);
                    this.context.updateNotificationContext({
                        documentIsFinal: defect.showtasknotification === 1,
                        path: this.props.location.pathname,
                        referenceId: this.props.params.notificationid,
                        referenceType: this.props.workflowItem.config.referenceType,
                        workflowGroupId: this.props.workflowGroupItem.id,
                        workflowId: this.props.workflowItem.id,
                    });
                });
            })
            .catch(err => {
                if (!axios.isCancel(err)) {
                    this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                }
            });
    }

    fetchFiles = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, this.props.params.notificationid, this.props.documentType)
            const filesList = JSON.parse(data.aggregatelist)
            this.setState({ files: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }
    fetchReplyFiles = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, this.props.params.notificationid, this.props.documentType + 'Reply')
            const filesList = JSON.parse(data.aggregatelist)
            this.setState({ replyFiles: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }
    printHandler = () => {
        this.printIssueRef.handlePrint();
    }

    printAcceptanceHandler = () => {
        this.printAcceptanceRef.handlePrint();
    }
    validateForm = () => {
        const validationResult = this.validatorRef.current.instance().validate();
        if (!validationResult.isValid) {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_MISSING_FIELDS' }), { variant: 'warning', });
        }
        return validationResult.isValid && !this.state.saving;
    }

    showModal = async (mode, postActionNavigateObj) => {
        const { fields, replyFields } = this.props.workflowItem;
        let selectedClause = null;
        if (this.state.notification.inspectiontime && fields.Type.clauses) {
            selectedClause = fields.Type.clauses.find(c => c.display === this.state.notification.inspectiontime);
        }

        const notification = { ...this.state.notification };

        if (mode === 'COMMUNICATE') {
            if (this.validateForm()) {
                if (this.props.workflowItem.replyEnabled) {
                    let newReplyRequiredDate = null;

                    if (selectedClause && selectedClause.applyReplyPeriod && selectedClause.hasOwnProperty("replyPeriod")) {
                        newReplyRequiredDate = moment(addDays(new Date(), selectedClause.replyPeriod)).toDate();
                    }
                    else if (this.props.workflowItem.replyPeriodOption === "ASKED_ON_COMMUNICATION_FORM") {
                        //DO NOTHING, "replyrequireddate" ALREADY SET ON FORM
                    }
                    else {
                        // Reply Period is set whats assigned on Workflow Setting
                        newReplyRequiredDate = moment(addDays(new Date(), this.props.workflowItem.replyPeriod)).toDate();
                    }

                    const date1 = moment(this.state.oldReplyRequiredDate).format('YYYY-MM-DD');
                    const date2 = moment(newReplyRequiredDate).format('YYYY-MM-DD');

                    if (notification.replyrequireddate && newReplyRequiredDate && date1 !== date2) {
                        const userApprovalToContinue = await this.confirmUpdatedReplyRequiredDate();
                        if (!userApprovalToContinue) {
                            return; //cancelled
                        }
                    }

                }

                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_COMMUNICATE_ITEM' }, { ITEM_NAME: this.props.title }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_COMMUNICATING' }, { ITEM_NAME: this.props.title }),
                    modalMode: mode,
                    postActionUrl: postActionNavigateObj,
                    selectedClause
                });
            }
        }
        else if (mode === 'SAVE_DRAFT') {
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SAVE_DRAFT_NOTIFY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_SAVING' }),
                    modalMode: mode,
                });
            }
        }
        else if (mode === 'REPLY_DRAFT') {
            //show reply tab
            this.tabPanel.instance().option("selectedIndex", 1);
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SAVE_REPLY_DRAFT_NOTIFY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_SAVING' }),
                    modalMode: mode,
                });
            }
        }
        else if (mode === 'REPLY_SEND') {
            let selectedReply = null;
            const { fields, replyFields } = this.props.workflowItem;
            if (this.state.reply.replystatus && replyFields.ReplyStatus.replyOptions) {
                selectedReply = replyFields.ReplyStatus.replyOptions.find(c => c.field === this.state.reply.replystatus);
            }

            this.tabPanel.instance().option("selectedIndex", 1);
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SEND_REPLY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_REPLY_SENDING' }),
                    modalMode: mode,
                    selectedClause,
                    selectedReply
                });
            }
        }
        else if (mode === 'DELETE_DRAFT') {
            this.setState({
                showModal: true,
                modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DELETE_DRAFT_NOTIFY' }),
                modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_DELETING' }),
                modalMode: mode,
            });

        }
    }
    onModalResponse = (response, params) => {
        const { fields, replyFields } = this.props.workflowItem;
        this.setState({ showModal: false, saving: response === 'OK' }, async () => {
            try {
                if (response === 'OK') {
                    const selectedClause = fields.Type.clauses.find(item => item.display === this.state.notification.inspectiontime);
                    if (!selectedClause) {
                        console.log("Clause selection not found!");
                    }

                    if (this.state.modalMode === 'COMMUNICATE') {
                        const notification = { ...this.state.notification };
                        notification.createactions = params?.createactions;
                        notification.completeactions = params?.completeactions;
                        // notification.createby = this.props.contractUser.name;
                        notification.createbyid = this.props.contractUser.accountid;
                        // notification.notificationdatedisplay = moment().format('DD/MM/YYYY');

                        notification.showtasknotification = 1;





                        // if (this.props.workflowItem.replyEnabled && this.props.workflowItem.replyPeriodOption === "ASKED_ON_COMMUNICATION_FORM") {
                        //     notification.isreplyrequired = true;
                        //     notification.replystatus = 'Awaiting Acceptance';
                        //     //DO NOTHING, "replyrequireddate" ALREADY SET ON FORM
                        // }
                        // else if (!this.props.workflowItem.replyEnabled || (selectedClause && selectedClause.noReply)) {
                        //     notification.isreplyrequired = false;
                        //     notification.replystatus = 'Communicated';
                        // }
                        // else if (this.props.workflowItem.replyEnabled) {
                        //     let replyPeriod = 0;
                        //     notification.isreplyrequired = true;
                        //     notification.replystatus = 'Awaiting Acceptance';
                        //     if (selectedClause && selectedClause.applyReplyPeriod && selectedClause.hasOwnProperty("replyPeriod")) {
                        //         replyPeriod = selectedClause.replyPeriod;
                        //     }
                        //     else {
                        //         replyPeriod = this.props.replyPeriod;
                        //     }
                        //     notification.replyrequireddate = moment(addDays(new Date(), replyPeriod)).toDate();
                        // }
                        if (!this.props.workflowItem.replyEnabled || (selectedClause && selectedClause.noReply)) {
                            //reply not possible
                            notification.isreplyrequired = false;
                            notification.replystatus = 'Communicated';
                            notification.replyrequireddate = null;
                            notification.replyrequireddatedisplay = null;
                        }
                        else if (this.props.workflowItem.replyEnabled) {
                            notification.isreplyrequired = true;
                            notification.replystatus = 'Awaiting Acceptance';
                            if (selectedClause && selectedClause.applyReplyPeriod && selectedClause.hasOwnProperty("replyPeriod")) {
                                notification.replyrequireddate = moment(addDays(new Date(), selectedClause.replyPeriod)).toDate();
                            }
                            else if (this.props.workflowItem.replyPeriodOption === "ASKED_ON_COMMUNICATION_FORM") {
                                //DO NOTHING, "replyrequireddate" ALREADY SET ON FORM
                            }
                            else {
                                // Reply Period is set whats assigned on Workflow Setting
                                notification.replyrequireddate = moment(addDays(new Date(), this.props.workflowItem.replyPeriod)).toDate();
                            }

                            //ASSIGN RESUBMIT DAYS
                            notification.resubmitperiodindays = this.props.workflowItem.resubmitPeriod;
                            if (selectedClause && selectedClause.applyResubmitPeriod && selectedClause.hasOwnProperty("resubmitPeriod")) {
                                notification.resubmitperiodindays = selectedClause.resubmitPeriod;
                            }
                        }
                        const docBodyConfig = this.documentBodyConfig(notification, this.props.resources);
                        const docConfig = await this.documentConfig(notification, docBodyConfig, this.props.contractUser.name, false, null, null, this.props.workflowItem.form_NotifyCompanyName);
                        notification.pdfjsoncontent = JSON.stringify(docConfig);

                        this.saveIssue(notification, this.state.modalMode);

                    }
                    else if (this.state.modalMode === 'SAVE_DRAFT') {
                        const notification = { ...this.state.notification };
                        if ((params || {}).userid) {
                            notification.lastdraftednotifiedto = params.userid;
                        }
                        // notification.createby = this.props.contractUser.name;
                        notification.createbyid = this.props.contractUser.accountid;
                        if (!this.props.workflowItem.replyEnabled || (selectedClause && selectedClause.noReply)) {
                            notification.replyrequireddate = null;
                            notification.replyrequireddatedisplay = null;
                        }

                        this.saveIssue(notification, this.state.modalMode, params ? params.userid : null);

                    }
                    else if (this.state.modalMode === 'REPLY_DRAFT') {
                        const reply = { ...this.state.reply };
                        const notification = { ...this.state.notification };
                        notification.draftinspectionstatus = reply.replystatus;
                        notification.draftreplycomment = reply.replycomment;
                        notification.draftreplystatus = 'Drafted';
                        notification.draftreplybyid = this.props.contractUser.accountid;
                        if ((params || {}).userid) {
                            notification.draftreplytoid = params.userid;
                        }
                        notification.draftreplydatedisplay = moment().format('DD/MM/YYYY');
                        this.saveIssue(notification, this.state.modalMode, (params || {}).userid);

                    }
                    else if (this.state.modalMode === 'DELETE_DRAFT') {
                        const submission = { ...this.state.notification };
                        const submissionid = submission.inspectiondefectid
                        this.deleteSubmissionDraft(submissionid);

                    }
                    else if (this.state.modalMode === 'REPLY_SEND') {
                        const reply = { ...this.state.reply };
                        if (!this.replyValidation(reply)) {
                            //FINAL REPLY FIELDS CHECK FAILED
                            throw new Error(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_REPLY_FIELDS_MISSING' }))
                        }

                        const notification = { ...this.state.notification };
                        notification.createactions = params?.createactions;
                        notification.completeactions = params?.completeactions;
                        notification.replystatus = reply.replystatus;
                        notification.replycomment = reply.replycomment;
                        for (let key in reply) {
                            if (key.startsWith("CF_")) {
                                notification[key] = reply[key];
                            }
                        }

                        const docReplyBodyConfig = this.documentReplyBodyConfig(notification, this.props.resources);
                        let notifyCompanyName = this.props.workflowItem.form_ReplyCompanyName;
                        if (this.state.overrideReplyParty && this.props.workflowItem.form_CompanyLogo === 'PARTY') {
                            notifyCompanyName = Common.GetPartyOrUserCompanyName(this.props.contract, this.props.workflowItem.form_CompanyLogo, notification.replyingparty, this.props.userProfile)
                        }
                        const docReplyConfig = await this.documentConfig(notification, docReplyBodyConfig, this.props.contractUser.name, true, null, null, notifyCompanyName);
                        notification.pdfreplyjsoncontent = JSON.stringify(docReplyConfig);

                        this.onSubmitReply(notification);


                    }


                }
            } catch (err) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                this.setState({ saving: false });
            }

        });
    }
    deleteSubmissionDraft = async (inspectionid) => {

        try {
            await inspectionCrud.deleteInspectionDraft(inspectionid);
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_DELETED' }), { variant: 'success' });
            this.setState({ saving: false, navigateto: this.props.workflowItem.paths.listPath });

        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            this.setState({ saving: false });
        }
    }
    confirmUpdatedReplyRequiredDate = async () => {
        const warningMessage = this.props.intl.formatMessage({ id: 'GENERAL.WARNING.REPLY_REQUIRED_DATE_UPDATED' });
        const warningMessageLabel = this.props.intl.formatMessage({ id: 'GENERAL.WARNING.REPLY_REQUIRED_DATE_CONFIRMATION' });
        let result = await confirm(`<div style="max-width:50vw;">${warningMessage}</div>`, `${warningMessageLabel}`);

        return result;
    }
    replyValidation = (reply) => {
        if (!reply.replystatus) { return false; }
        if (!["NO_REPLY_REQUIRED", "Reply Not Required"].includes(reply.replystatus) && !reply.replycomment) { return false; }
        return true;
    }
    documentBodyConfig = (notification, resources) => {
        const { fields } = this.props.workflowItem;
        const bodyConfig = [];
        if (fields.Subject.visible) {
            bodyConfig.push({ label: fields.Subject.label, value: notification.replyactiondetail });
        }
        if (fields.Type.visible) {
            bodyConfig.push({ label: fields.Type.label, value: notification.inspectiontime });
        }
        if (notification.isreplyrequired) {
            bodyConfig.push({ label: fields.ResponseRequiredDate.label, value: notification.replyrequireddate, });
        }
        if (fields.Details.visible) {
            bodyConfig.push(
                { resource: 'GENERAL.FORMS.FIELD.DETAILS', value: notification.inspectiondetails, valueType: 'HTML', align: 'vertical' },
            );
        }
        return bodyConfig;
    }
    documentReplyBodyConfig = (notification, resources) => {
        const { fields, replyFields } = this.props.workflowItem;
        let statusDisplay = "UNKNOWN";
        const selectedReply = replyFields.ReplyStatus.replyOptions.find(opt => opt.field === notification.replystatus);
        if (selectedReply) {
            statusDisplay = selectedReply.display;
        }

        const config = [
            { resource: 'GENERAL.FORMS.FIELD.SUBJECT', value: notification.replyactiondetail, },
            { resource: 'GENERAL.FORMS.FIELD.CLAUSE', value: notification.inspectiontime, },
            { resource: "GENERAL.FORMS.FIELD.REPLY", value: statusDisplay },


        ];
        if (!["NO_REPLY_REQUIRED", "Reply Not Required"].includes(notification.replystatus)) {
            config.push({ resource: "GENERAL.FORMS.FIELD.REPLY_DETAIL", value: notification.replycomment, valueType: 'HTML', align: 'vertical' });
        }

        return config;
    }
    onSubmitReply = (issue) => {
        // issue.createbyid = issue.createby;
        // issue.notificationdatedisplay = moment(new Date(issue.notificationdate)).format('DD/MM/YYYY');
        issue.inspectionbyid = this.props.contractUser.accountid;
        // issue.replydatedisplay = moment().format('DD/MM/YYYY');
        this.saveIssue(issue, this.state.modalMode);
    }

    saveIssue = (issue, action, notifyuserid) => {
        const postEvents = () => {
            this.fetchInspectionDefect();

            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.SAVED_SUCCESS' }), { variant: 'success', });
        };

        if (!issue.inspectiondatedisplay && !issue.inspectiondatedisplay && issue.inspectiondate) {
            issue.inspectiondatedisplay = moment(issue.inspectiondate).format('DD/MM/YYYY HH:mm:ss');
        }
        if (!issue.draftreplydatedisplay && issue.draftreplydate) {
            issue.draftreplydatedisplay = moment(issue.draftreplydate).format('DD/MM/YYYY');
        }

        issue.actioncode = action;
        issue.notifyuserlist = this.getNotifyUserListForUpdate(action, notifyuserid);
        Common.PropertyConversionsBeforeNoticeSaveRequest(issue, this.props.customFields, this.props.contractUsers);
        inspectionCrud.updateInspectionDefect(issue)
            .then(() => {
                if (this.state.postActionUrl) {
                    this.setState({ isChanged: false, saving: false, navigateto: this.state.postActionUrl.pathname });
                }
                else {
                    postEvents();
                }
            })
            .catch(err => {
                this.setState({ saving: false });
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            });
    }
    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        const { fields, replyFields } = this.props.workflowItem;
        //SILENT STATE CHANGE
        //WE DONT WANT COMPONENT RERENDER WİTH THIS
        //this.setState({ notification: { ...this.state.notification, [field]: value } });
        if (field) {
            if (field === "assetid") {
                this.setState({
                    notification: { ...this.state.notification, [field]: value, asset: { ...additionalData } },
                    isChanged: true
                });
            }
            else if (field === 'inspectiontime' && this.props.workflowItem.replyEnabled) {
                const selectedClause = fields.Type.clauses.find(item => item.display === value);
                let newReplyingParty = this.props.workflowItem.replyingParty;
                if (selectedClause && selectedClause.overrideReplyingParty) {
                    newReplyingParty = selectedClause.replyingParty;
                }
                this.setState({
                    notification: { ...this.state.notification, [field]: value, replyingparty: newReplyingParty },
                    isChanged: true
                });
            }
            else {
                this.state.notification[field] = value;
                if (!this.state.isChanged) {
                    this.setState({ isChanged: true });
                }
            }
        }
    }
    replyFieldChanged = (field, value, isDxReplyFormValid, isCheckBoxValue) => {
        //SILENT STATE CHANGE
        //WE DONT WANT COMPONENT RERENDER WİTH THIS
        //this.setState({ notification: { ...this.state.notification, [field]: value } });
        if (field) {
            this.state.reply[field] = value;
            if (!this.state.isChanged) {
                this.setState({ isChanged: true });
            }
        }

    }

    renderToolbar = (documentIsFinal) => {
        const saveDisabled = (this.state.saving || this.state.showModal || this.state.fileUploading);
        return (
            <PageToolbar
                key={this.state.notification.version}
                documentIsFinal={documentIsFinal}
                saveDisabled={saveDisabled}
                isAwaitingReply={this.state.isAwaitingReply}
                actions={{
                    showModal: this.showModal,
                    onPrintReply: this.printAcceptanceHandler,
                    onPrint: this.printHandler
                }}
                workflowItem={this.props.workflowItem}
                match={this.props.match}
                customFieldValues={this.state.notification.customfieldvalues}
                referenceid={this.state.notification.referenceid}
                contract={this.props.contract}
                relationParams={{
                    subject: this.getMailDescription(),
                    assetid: this.state.notification.assetid
                }}
                overrideReplyParty={this.state.overrideReplyParty}
                overrideSaveDraftReplyAllowed={this.state.overrideSaveDraftReplyAllowed}
                overrideCommunicateReplyAllowed={this.state.overrideCommunicateReplyAllowed}
                notification={this.state.notification}
                selectedClausetypeDisplay={this.getSelectedTypeClauseDisplay()}
            />
        );
    }
    tabDocument = () => {
        return (
            <IssueDocument
                {...this.props}
                printDivRef={this.printIssueDivRef}
                fieldChanged={this.fieldChanged}
                notification={this.state.notification}
                files={this.state.files}

                notificationid={this.props.params.notificationid}
                saving={this.state.saving}
                onFileUploadFinish={() => this.setState({ fileUploading: false })}
                onFileUploadStart={() => this.setState({ fileUploading: true })}
            />
        );
    }
    tabReply = (documentIsFinal) => {
        const { saveDraftReplyAllowed, communicateReplyAllowed } = this.props.workflowItem.userFilters.replyNotice;
        let canSeeReplyDraft = communicateReplyAllowed || saveDraftReplyAllowed;
        if (this.state.overrideReplyParty) {
            canSeeReplyDraft = this.state.overrideSaveDraftReplyAllowed || this.state.overrideCommunicateReplyAllowed;
        }
        if (!canSeeReplyDraft && this.state.isAwaitingReply) {
            return (
                <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                    <div style={{ width: '100%', maxWidth: '900px', margin: '20px' }}>
                        <Alert variant="warning" >
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_AWAITING_REPLY" values={{ ITEM_NAME: this.props.workflowItem.pageTitle }} />
                            </p>
                        </Alert>
                    </div>
                </div>
            )
        }
        else {
            return (
                <ReplyDocument
                    {...this.props}
                    isAwaitingReply={this.state.isAwaitingReply}
                    printDivRef={this.printAcceptanceDivRef}
                    fieldChanged={this.replyFieldChanged}
                    notification={this.state.notification}
                    reply={this.state.reply}
                    files={this.state.replyFiles}
                    notificationid={this.props.params.notificationid}
                    overrideReplyParty={this.state.overrideReplyParty}
                    overrideReplyPartyValue={this.state.notification.replyingparty}
                    saving={this.state.saving}
                    onFileUploadFinish={() => this.setState({ fileUploading: false })}
                    onFileUploadStart={() => this.setState({ fileUploading: true })}
                />
            )
        }
    }
    tabRelations = () => {
        return (
            <Relations
                contractid={this.props.contract.contractid}
                workflowItem={this.props.workflowItem}
                workflowGroupItem={this.props.workflowGroupItem}
                notificationid={Number(this.props.params.notificationid)}
                relations={this.state.notification.relations}
                itemversion={this.state.notification.version}
                subject={this.state.notification.replyactiondetail}
                onCountChange={(count) => this.setState({ relationCount: count })}
                showTags={this.props.contract.specifictags?.length > 0}
                assetid={this.state.notification.assetid}
            />
        );
    }
    tabEmailNotification = () => {

        return (
            <EmailNotifications
                {...this.props}
                notificationDate={this.state.notification.notificationdate}
            />
        );

    };

    render() {
        if (!this.state.notification || !this.state.files || !this.state.replyFiles) {
            return (<PortletSpinner />);
        }
        const documentIsFinal = this.state.notification.showtasknotification === 1;
        const showReply = documentIsFinal && this.state.notification.isreplyrequired;
        if (!documentIsFinal && !this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed) {
            return (<Navigate replace to={this.props.workflowItem.paths.listPath} />)
        }
        return (
            <Portlet>
                <ReactToPrint
                    ref={el => (this.printIssueRef = el)}
                    trigger={() => (<div style={{ display: 'none' }} ></div>)}
                    content={() => this.printIssueDivRef.current}
                />
                <ReactToPrint
                    ref={el => (this.printAcceptanceRef = el)}
                    trigger={() => (<div style={{ display: 'none' }} ></div>)}
                    content={() => this.printAcceptanceDivRef.current}
                />
                <NavigationBlocker
                    when={(this.state.isChanged || this.state.saving)}
                    message={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_UNSAVED' })}
                />
                {this.state.navigateto &&
                    (
                        <Navigate replace to={this.state.navigateto} state={(this.state.postActionUrl || {}).state} />
                    )
                }
                <PortletHeader
                    title={documentIsFinal ? this.props.workflowItem.pageTitle : this.props.intl.formatMessage({ id: "GENERAL.FORMS.DRAFT_TITLE" }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                    toolbar={this.renderToolbar(documentIsFinal)}
                />
                <PortletBody>
                    <ValidationGroup ref={this.validatorRef} name={this.validatorName}>
                        <div>
                            <ValidationSummary elementAttr={{ align: "right", paddingBottom: 50 }} id={this.validatorName}></ValidationSummary>
                        </div>
                        <TabPanel
                            ref={(ref) => this.tabPanel = ref}
                            width="100%"
                            deferRendering={false}
                            animationEnabled={true}
                            focusStateEnabled={true}
                            hoverStateEnabled={true}
                            swipeEnabled={false}
                        >
                            <Item icon="file" title={this.props.title} render={this.tabDocument} />
                            <Item icon="rename" title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_REPLY' })} render={showReply ? this.tabReply : null} visible={showReply} />
                            {
                                this.isRelationsEnabled && (
                                    <Item icon="share" title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_RELATIONS' })} render={this.tabRelations} badge={this.state.relationCount > 0 ? this.state.relationCount : null} />
                                )
                            }
                            <Item
                                icon="bulletlist"
                                title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_EMAIL_NOTIFICATIONS' })}
                                render={documentIsFinal ? this.tabEmailNotification : null} visible={documentIsFinal}
                            />
                        </TabPanel>
                    </ValidationGroup>
                </PortletBody>
                <ActionModal
                    visible={this.state.showModal}
                    title={this.state.modalTitle}
                    text={this.state.modalText}
                    mode={this.state.modalMode}
                    onDialogResult={this.onModalResponse}
                    workflowItem={this.props.workflowItem}
                    selectedClause={this.state.selectedClause}
                    overrideReplyParty={this.state.overrideReplyParty}
                    overrideReplyPartyValue={this.state.notification.replyingparty}
                    selectedReply={this.state.selectedReply}
                />
            </Portlet>
        );
    }
}


export default withDetailPageProps(IssueDetail);
